import { connect } from 'react-redux';

export const FeatureFlagsAvailable = (name, featureFlags) => {
  if (!name) {
    return true;
  }

  if (featureFlags[name]) {
    return true;
  }

  return false;
};

const FeatureFlags = ({ children, name, featureFlags = {} }) => {
  if (FeatureFlagsAvailable(name, featureFlags)) {
    return children;
  }
  return null;
};

export default connect(({ user: { featureFlags } }) => ({ featureFlags }), {})(FeatureFlags);
